import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { set } from "date-fns";

export default function FormularioBaja({
  modo = "insertar",
  idRegistro: idRegistroProp,
  onAplicado,
}) {
  const { selectedNomina } = useOutletContext();
  const [show, setShow] = useState(false);
  const [empleado, setEmpleado] = useState(null);
  const [empleados, setEmpleados] = useState([]);
  const [motivosBaja, setMotivosBaja] = useState([]);
  const [motivosBajaIMSS, setMotivosBajaIMSS] = useState([]);
  const [motivoBaja, setMotivoBaja] = useState(null);
  const [fechaBaja, setFechaBaja] = useState(null);
  const [motivoImss, setMotivoImss] = useState(null);
  const [fechaImss, setFechaImss] = useState(null);
  const [recontratable, setRecontratable] = useState(null);
  const [tipoBaja, setTipoBaja] = useState(null);
const [fechaImssEditada, setFechaImssEditada] = useState(false); // ← nuevo estado
  const [observaciones, setObservaciones] = useState("");
  const toast = useRef(null);
  const navigate = useNavigate();

  //const { idRegistro } = useParams();
  const params = useParams();
  const idRegistro = idRegistroProp || params.idRegistro;
  const axiosPrivate = useAxiosPrivate();
  const [mensaje, setMensaje] = useState("");
  const [catalogosCargados, setCatalogosCargados] = useState(false);
  const handleBack = () => {
    navigate(-1);
  };

  const handleFechaBajaChange = (e) => {
  const nuevaFecha = e.value;
  setFechaBaja(nuevaFecha);
  if (!fechaImssEditada) {
    setFechaImss(nuevaFecha);
  }
};

const handleFechaImssChange = (e) => {
  setFechaImss(e.value);
  setFechaImssEditada(true);
};
  const getData = async () => {
    if (!selectedNomina) return;

    const resEmpleados = await axiosPrivate.get(
      `/NOM/empleados/Select/${selectedNomina.idNomina}`
    );
    setEmpleados(resEmpleados.data);

    const resMotivoBaja = await axiosPrivate.get(`/NOM/motivosBaja/Select/`);
    setMotivosBaja(resMotivoBaja.data);

    const resMotivoBajaIMSS = await axiosPrivate.get(
      `/NOM/motivosBajaIMSS/Select/`
    );
    setMotivosBajaIMSS(resMotivoBajaIMSS.data);

    setCatalogosCargados(true); // 🚨 Marca como listo
    console.log("Datos cargados:", {
      empleados: resEmpleados.data,
      motivosBaja: resMotivoBaja.data,
      motivosBajaIMSS: resMotivoBajaIMSS.data,
    });
  };

  useEffect(() => {
    getData();
  }, [selectedNomina]);

  useEffect(() => {
    const fetchFalta = async () => {
      if (!idRegistro || !catalogosCargados) return;
      try {
        console.log("Cargando baja con ID:", idRegistro);
        const response = await axiosPrivate.get(
          `/NOM/baja-empleados/${idRegistro}`
        );
        const {
          numero,
          motivoBaja,
          fechaBaja,
          motivoBajaIMSS,
          fechaBajaIMSS,
          recontratable,
          tipoBaja,
          observaciones,
        } = response.data;
        console.log("Datos de la baja:", response.data);

        setMotivoBaja(motivosBaja.find((mot) => mot.numero === motivoBaja));
        setMotivoImss(          motivosBajaIMSS.find((mot) => mot.numero === motivoBajaIMSS)        );
        setFechaBaja(new Date(fechaBaja));
        setFechaImss(new Date(fechaBajaIMSS));
        setRecontratable(recontratable?.data?.[0] ? "si" : "no");
        setTipoBaja(tipoBaja);
        setObservaciones(observaciones || "");

        const empleadoEncontrado = empleados.find(
          (emp) => emp.numero === numero
        );
        setEmpleado(empleadoEncontrado || null);
      } catch (error) {
        console.error("Error al cargar la baja:", error);
      }
    };
    console.log("Cargando baja con ID:", idRegistro);
    fetchFalta();
  }, [catalogosCargados, idRegistro]);

  const handleSubmit = async () => {
    if (!empleado) {
      setErrMsg("Indique el empleado para asignar la baja.");
      return;
    }
    if (!motivoBaja) {
      setErrMsg("Indique el motivo de la baja.");
      return;
    }
    if (!fechaBaja) {
      setErrMsg("Ingrese la fecha de baja para el empleado.");
      return;
    }
    if (!motivoImss) {
      setErrMsg("Indique el motivo de falta para el IMSS.");
      return;
    }
    if (!recontratable) {
      setErrMsg("Seleccione si el empleado es recontratable.");
      return;
    }
    if (!tipoBaja) {
      setErrMsg("Seleccione el tipo de baja.");
      return;
    }

    const data = {
      id: idRegistro,
      numero: empleado.numero,
      nombre: empleado.nombreCompleto,
      motivoBaja: motivoBaja.numero,
      fechaBaja,
      motivoImss: motivoImss.numero,
      fechaImss,
      recontratable: recontratable === "si" ? 1 : 0,
      tipoBaja,
      observaciones,
      idNomina: selectedNomina.idNomina,
      periodo: `${
        selectedNomina.YearPeriodo
      }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`,
    };
    console.log("recontratable value:", data);
    //return;
    if (modo === "aplicar") {
      try {
        console.log("Aplicando baja con datos:", data);
        const aplicarResponse = await axiosPrivate.post(
          `/NOM/baja-empleados/aplicar`,
          data 
        );

        toast.current.show({
          severity: "success",
          summary: "Aplicado",
          detail: aplicarResponse?.data?.msg || "Baja aplicada",
          life: 3000,
        });

        setShow(false);

        if (typeof onAplicado === "function") {
          await onAplicado();
        }

        return;
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "No se pudo aplicar la baja",
        });
      }
      return;
    }

    try {

      console.log(data);
      const response = idRegistro
        ? await axiosPrivate.put(`/NOM/baja-empleados/${idRegistro}`, data)
        : await axiosPrivate.post("NOM/baja-empleados", data);
      if (!idRegistro) {
        setEmpleado(null);
      }

      setShow(false);
      setMensaje(response?.data.msg);
      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: response?.data.msg,
        life: 3000,
      });
    } catch (err) {
      console.error(err);
      setErrMsg("Error al registrar la excepción.");
    }
  };
  const [errMsg, setErrMsg] = useState("");

  return (
    <div className="p-4">
      <Toast ref={toast} />
      {modo !== "aplicar" && (
        <>
          <h2 className="mb-4">Registro de baja de empleados</h2>
          <div className="mb-3 flex justify-content-between">
            <Button
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-secondary"
              onClick={handleBack}
            />
            <Button
              label="Ver registros"
              icon="pi pi-list"
              className="p-button-info"
              onClick={() =>
                navigate(
                  `/baja-empleados/listado?periodo=${
                    selectedNomina.YearPeriodo
                  }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`
                )
              }
            />
          </div>
        </>
      )}
      {errMsg && <small className="p-error">{errMsg}</small>}

      <div className="p-fluid grid formgrid">
        <div className="field col-12 md:col-6">
          <label htmlFor="empleado">Empleado</label>
          <Dropdown
            id="empleado"
            value={empleado}
            options={empleados}
            onChange={(e) => setEmpleado(e.value)}
            optionLabel="label"
            placeholder="Seleccione un empleado"
            filter
            showClear
          />
        </div>

        <div className="field col-12 md:col-3">
          <label htmlFor="motivoBaja">Motivo de baja</label>
          <Dropdown
            id="motivoBaja"
            value={motivoBaja}
            options={motivosBaja}
            onChange={(e) => setMotivoBaja(e.value)}
            placeholder="Selecciona una opción"
            optionLabel="Descripcion"
          />
        </div>

        <div className="field col-12 md:col-3">
          <label htmlFor="fechaBaja">Fecha de baja</label>
          <Calendar
            id="fechaBaja"
            value={fechaBaja}
            onChange={handleFechaBajaChange}
            dateFormat="dd/mm/yy"
            showIcon
          />
        </div>

        <div className="field col-12 md:col-3">
          <label htmlFor="motivoImss">Motivo de baja IMSS</label>
          <Dropdown
            id="motivoImss"
            value={motivoImss}
            options={motivosBajaIMSS}
            //onChange={handleFechaImssChange}
          onChange={(e) => setMotivoImss(e.value)}
            placeholder="Selecciona una opción"
            optionLabel="Descripcion"
          />
        </div>

        <div className="field col-12 md:col-3">
          <label htmlFor="fechaImss">Fecha de baja IMSS</label>
          <Calendar
            id="fechaImss"
            value={fechaImss}
            onChange={(e) => setFechaImss(e.value)}
            dateFormat="dd/mm/yy"
            showIcon
          />
        </div>

        <div className="field col-12 md:col-3">
          <label>Recontratable</label>
          <div className="flex gap-3 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="recon-si"
                name="recontratable"
                value="si"
                onChange={(e) => setRecontratable(e.value)}
                checked={recontratable === "si"}
              />
              <label htmlFor="recon-si" className="ml-2">
                Sí
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="recon-no"
                name="recontratable"
                value="no"
                onChange={(e) => setRecontratable(e.value)}
                checked={recontratable === "no"}
              />
              <label htmlFor="recon-no" className="ml-2">
                No
              </label>
            </div>
          </div>
        </div>

        <div className="field col-12 md:col-3">
          <label>Tipo de baja</label>
          <div className="flex gap-3 mt-2">
            <div className="flex align-items-center">
              <RadioButton
                inputId="voluntaria"
                name="tipoBaja"
                value="voluntaria"
                onChange={(e) => setTipoBaja(e.value)}
                checked={tipoBaja === "voluntaria"}
              />
              <label htmlFor="voluntaria" className="ml-2">
                Voluntaria
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="involuntaria"
                name="tipoBaja"
                value="involuntaria"
                onChange={(e) => setTipoBaja(e.value)}
                checked={tipoBaja === "involuntaria"}
              />
              <label htmlFor="involuntaria" className="ml-2">
                Involuntaria
              </label>
            </div>
          </div>
        </div>

        <div className="field col-12">
          <label htmlFor="observaciones">Observaciones</label>
          <InputTextarea
            id="observaciones"
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
            rows={3}
            autoResize
          />
        </div>
      </div>

      <div className="p-fluid p-formgrid grid">
        {/* <div className="field col-12 md:col-6">
          <label htmlFor="empleado">Empleado</label>
        </div> */}

        <div className="field col-12">
          <Button
            label={
              modo === "aplicar"
                ? "Aplicar en Nómina"
                : idRegistro
                ? "Actualizar"
                : "Registrar"
            }
            icon="pi pi-check"
            onClick={() => setShow(true)}
          />
        </div>
      </div>

      <Dialog
        header={modo === "aplicar" ? "Aplicar baja en nómina" : "Confirmación"}
        visible={show}
        style={{ width: "50vw" }}
        modal
        onHide={() => setShow(false)}
      >
        <p>
          {modo === "aplicar"
            ? "¿Desea aplicar esta baja a la nómina?"
            : "¿Está seguro que desea registrar la solicitud de baja?"}
        </p>
        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            className="p-button-text"
            onClick={() => setShow(false)}
          />
          <Button
            label="Confirmar"
            icon="pi pi-check"
            autoFocus
            onClick={handleSubmit}
          />
        </div>
      </Dialog>
    </div>
  );
}
